export const oneSecondInMilliseconds = 1000;
export const oneMinuteInMilliseconds = 60 * oneSecondInMilliseconds;
export const oneHourInMilliseconds = 60 * oneMinuteInMilliseconds;
export const oneDayInMilliseconds = 24 * oneHourInMilliseconds;

export const cacheRefreshVariance = 0.1;
